<div class="context-toast --is-{{status}}">
    @if (iconName) {<ion-icon class="context-toast__icon" [name]="iconName"></ion-icon>}
    @if (text) {<p class="context-toast__text" [innerHTML]="text"></p>}
</div>